export const BRAND = "Globex";
export const BRAND_LEGAL = "Globex Sdn Bhd";
export const BRAND_TAGLINE = "Sdn Bhd · KL · SG";

export const WHATSAPP_NUMBER_DISPLAY = "+60 17-647 2339";
export const WHATSAPP_URL =
  "https://wa.me/60176472339?text=" +
  encodeURIComponent("Hello Globex team, I'm interested in a membership plan. Please advise.");

export const planWhatsAppUrl = (plan, cycle) =>
  "https://wa.me/60176472339?text=" +
  encodeURIComponent(`Hello Globex team, I want to join the ${plan} plan (${cycle}). Please share next steps.`);

export const IMAGES = {
  tradingScreen:
    "https://images.unsplash.com/photo-1611974789855-9c2a0a7236a3?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBmaW5hbmNpYWwlMjBjaGFydHMlMjBzY3JlZW4lMjB0cmFkaW5nJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc5MDU2ODY1Nnww&ixlib=rb-4.1.0&q=85",
  analytics:
    "https://images.unsplash.com/photo-1551288049-bebda4e38f71?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBmaW5hbmNpYWwlMjBjaGFydHMlMjBzY3JlZW4lMjB0cmFkaW5nJTIwYW5hbHl0aWNzfGVufDB8fHx8MTc5MDU2ODY1Nnww&ixlib=rb-4.1.0&q=85",
  desk:
    "https://images.unsplash.com/photo-1789922129938-f02af2785d19?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHw0fHxzdG9jayUyMG1hcmtldCUyMHRyYWRlciUyMG11bHRpJTIwbW9uaXRvciUyMGRhcmslMjBvZmZpY2V8ZW58MHx8fHwxNzkwNTY4NjU2fDA&ixlib=rb-4.1.0&q=85",
  trader:
    "https://images.unsplash.com/photo-1758520145147-c30bc656f314?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzh8MHwxfHNlYXJjaHwyfHxzdG9jayUyMG1hcmtldCUyMHRyYWRlciUyMG11bHRpJTIwbW9uaXRvciUyMGRhcmslMjBvZmZpY2V8ZW58MHx8fHwxNzkwNTY4NjU2fDA&ixlib=rb-4.1.0&q=85",
};

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
